import Section from "./Section";

import Carousel from "./Carousel";
import { slides } from "../data/serviceData";

const ServiceSection = () => {
	return (
		<Section id="services" label="Service" bgClass="">
			{(visible) => (
				<div className="section-content">
					<div className="section-left">
						<div className="left-content-box">
							<div className="text-bg">
								<h2
									className={`left-title ${visible ? "animate-title" : ""}`}
									style={{
										animationDelay:
											visible
												? "0.2s"
												: "0s",
									}}
								>
									Professional Construction Framing Services in Southern California
								</h2>
								<p
									className={`left-desc ${visible ? "animate-desc" : ""}`}
									style={{
										animationDelay:
											visible
												? "0.7s"
												: "0s", // 0.5s after title
									}}
								>
									
Our framing services provide the structural foundation for residential and commercial construction projects throughout Southern California. From custom home builds to large-scale developments, professional framing ensures buildings meet load requirements, safety standards, and local building codes while supporting long-term structural performance.
									<br />
									<br />
									Reliable framing is essential for creating safe, durable, and efficient structures that stand the test of time. Using premium materials and proven construction techniques, our team ensures every structure is level, square, and built for durability, efficiency, and seamless integration with future construction phases.{" "}
								</p>
							</div>
						</div>
					</div>

					<div className="section-divider" />

					<div className="section-right">
						<Carousel
							slides={slides}
							delay={0.2}
							visible={visible}
						/>
					</div>
				</div>
			)}
		</Section>
	);
};

export default ServiceSection;
